import { parseErrorResponse } from "./ErrorParser";
import { getPortalToken } from "shared/utility/AuthUtility";
import {
  getConfigurationBaseUrl,
  getTimePhasingApiUrl,
} from "../utility/ConfigUtility";
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export function WithInterceptors(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    handleSuccessfulRequest,
    handleFailedRequest
  );
  return axiosInstance;
}

export function WithAuthenticationInterceptors(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
    if (
      (config.baseURL === getConfigurationBaseUrl() ||
        config.baseURL === getTimePhasingApiUrl()) &&
      !config.headers.Authorization
    ) {
      const token = getPortalToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  axiosInstance.interceptors.response.use(
    handleSuccessfulRequest,
    handleFailedRequest
  );
  return axiosInstance;
}

function handleSuccessfulRequest(response: AxiosResponse<any>) {
  return response;
}

function handleFailedRequest(error: AxiosResponse<any>) {
  const parsedError = parseErrorResponse(error);
  return Promise.reject(parsedError);
}
